import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import dataMap from 'lib/dataMap'
import PlaceLookup from 'components/GoogleMaps/PlaceLookup'

import { travelTypesList, } from 'core'

import './styles.css'

class EditTrip extends Component {
  static propTypes = {
    tripId: PropTypes.string.isRequired,
    tripData: PropTypes.shape({
      events: PropTypes.array,
    }).isRequired,
    addTripLocation: PropTypes.func.isRequired,
  }

  state = {
    nextLocation: {
      type: 'flight',
      departFrom: '',
      departureDate: '',
      departureTime: '',
      arrivalTime: '',
    },
  }

  componentWillMount() {
    this.setNextLocationDefaults()
  }

  componentWillReceiveProps() {
    this.setNextLocationDefaults()
  }

  placeFound = ({ place, }) => {
    const { tripId, } = this.props
    const { nextLocation, } = this.state
    // googlePlaceToLocation returns name, lat and lng
    const location = dataMap.googlePlaceToLocation(place)
    const newLocation = { ...nextLocation, }
    location.arrive = nextLocation.departureDate
    newLocation.arriveAt = location.name
    // for now we just set one 'to' item but it can support multiple (hence the array)
    const to = [newLocation]
    this.props.addTripLocation({
      tripId,
      location,
      to,
    })
  }

  handleChange = (event) => {
    const { nextLocation, } = this.state
    // TODO: set the arrival date to departure date if has no value
    // TODO: date validation
    nextLocation[event.target.name] = event.target.value
    this.setState({ nextLocation, })
  }

  setNextLocationDefaults = () => {
    const { tripData, } = this.props
    const lastEvent = tripData.events[tripData.events.length - 1]
    const minDepartureDate = lastEvent.depart || lastEvent.arrive
    const { nextLocation, } = this.state
    nextLocation.departFrom = lastEvent.name
    nextLocation.departureDate = moment(minDepartureDate)
      .add(1, 'days')
      .format('YYYY-MM-DD')
    nextLocation.departureTime = '09:00'
    nextLocation.arrivalTime = '10:00'
    this.setState({ nextLocation, })
  }

  render() {
    const { handleChange, } = this
    const { nextLocation, } = this.state

    const showPlaceLookup = !!(
      nextLocation.type &&
      nextLocation.departureDate &&
      nextLocation.departureTime &&
      nextLocation.arrivalTime
    )

    return (
      <div className="AddLocation">
        <div>
          <hr />
          <h2>Next location</h2>
          <div>TYPE DROPDOWN</div>
          <select
            id="travel-type"
            name="type"
            value={nextLocation.type}
            onChange={handleChange}
          >
            {travelTypesList.map(type =>
                (<option key={type.value} value={type.value}>
                  {type.descr}
                </option>)
            )}
          </select>
          <div>
            Departure Date
            <input
              type="date"
              name="departureDate"
              value={nextLocation.departureDate}
              onChange={handleChange}
            />
          </div>
          <div>
            Departure Time
            <input
              type="text"
              name="departureTime"
              value={nextLocation.departureTime}
              onChange={handleChange}
            />
          </div>
          <div>
            Arrival Time
            <input
              type="text"
              name="arrivalTime"
              value={nextLocation.arrivalTime}
              onChange={handleChange}
            />
          </div>
          {showPlaceLookup && (
            <div>
              Destination
              <PlaceLookup placeFound={this.placeFound} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default EditTrip



// WEBPACK FOOTER //
// ./src/components/EditTrip/AddLocation/index.js